import React from "react";
import { useHistory } from "react-router-dom";
import { Container, Button } from "reactstrap";
import { useAuth } from "hooks/useAuth";
import { BottomNav, BottomNavItem } from "components/BottomNav";
import { TriangleProgress } from "components/TriangleProgress";
import "react-circular-progressbar/dist/styles.css";
import "./profile.scss";

function Profile(props) {
  const { trials, glickoHistory, profile } = useAuth();
  const history = useHistory();
  if (!trials) {
    return "Retrieving your historical data...";
  }

  return (
    <>
      <Container className="profile-container">
        <div className="header">
          <img alt="SolveFaction logo" src="/logos/logo.svg" />
          <div className="header-brand">SolveFaction</div>
        </div>
        <div>
          <h2>{profile && profile.username}</h2>
        </div>
        <div className="level-wrapper">
          <TriangleProgress
            animSteps={[{ start: 0, end: 1, from: 1, to: 1 }]}
          />
        </div>

        {trials.length > 0 ? (
          <>
            <div className="exercise-progress-count">
              {`You have done ${trials.length} exercises so far`}
            </div>
            <div className="rating-container">
              <div className="rating-label">Current Rating</div>
              <div className="rating">
                {glickoHistory
                  ? Math.round(glickoHistory[glickoHistory.length - 1])
                  : "-"}
              </div>
            </div>
          </>
        ) : (
          <div className="start-msg-wrapper">
            Finish one practice session to get personalized exercises for your
            level.
          </div>
        )}

        <div className="footer">
          <Button
            className="btn-practice"
            color="primary"
            onClick={handleStartNewSession}
          >
            Practice
          </Button>
        </div>
      </Container>
      <BottomNav>
        <BottomNavItem
          iconUrl="/img/icons/triangle.svg"
          iconAlt="test"
          title="Practice"
        />
        <BottomNavItem
          iconUrl="/img/icons/trophy.svg"
          iconAlt="test"
          title="Leaderboard"
          onClick={() => {
            window.open("https://solvefaction.com/leaderboard");
          }}
        />
        <BottomNavItem
          iconUrl="/img/icons/user.svg"
          iconAlt="test"
          title="Profile"
        />
      </BottomNav>
    </>
  );

  function handleStartNewSession() {
    window.analytics.track("session.started");
    history.push(`/practice`);
  }
}

export { Profile };
